<template>
  <div :class="{ 'p-6': $mq != 'mobile', 'p-4 w-full': $mq == 'mobile' }">
    <p
      class="uppercase text-lg font-medium text-brand text-center my-4 sm:my-6"
      v-if="$mq == 'mobile'"
    >
      {{ form.billing.type == "direct-debit" ? "Direct Debit Request - " : "" }}
      Select your Payment Method and Details
    </p>
    <div :class="{ 'p-6 border': $mq != 'mobile' }">
      <div class="my-6 relative">
        <p
          class="uppercase text-lg font-light text-center my-6"
          v-if="$mq != 'mobile'"
        >
          {{
            form.billing.type == "direct-debit" ? "Direct Debit Request - " : ""
          }}
          Select your payment method and details
        </p>
        <div
          class="
            text-center
            sm:text-right sm:absolute sm:right-0 sm:top-0
            text-sm
            sm:text-xs
            font-light
            text-grey
          "
        >
          <span class="text-brand">*</span> Required fields
        </div>
      </div>

      <div class="py-4 mt-4">
        <mq-layout mq="tablet+" class="flex sm:flex-col-reverse md:flex-row">
          <div class="sm:w-3/5 md:w-1/2 pr-8 sm:mt-4">
            <label class="text-2xl font-light">Payment Method</label>
            <div class="w-full py-2 pb-0 pl-0 mt-4">
              <ul class="flex">
                <li v-for="(type, index) in paymentTypes" :key="index">
                  <label
                    class="
                      inline-block
                      py-4
                      px-4
                      text-left
                      border-l border-t border-r border-grey-light
                      font-medium
                    "
                    :class="{
                      'bg-white': index == form.billing.type,
                      'bg-grey-light': index != form.billing.type,
                    }"
                  >
                    <input
                      class="mr-2"
                      name="type"
                      type="radio"
                      v-model="form.billing.type"
                      :value="type.key"
                    />
                    {{ type.name }}
                  </label>
                </li>
              </ul>
            </div>
          </div>
          <div class="sm:w-full md:w-1/2 flex md:flex-row sm:flex-row">
            <div class="sm:w-full md:w-1/2 sm:pr-4">
              <label class="text-2xl font-light">Subscription Selected</label>
              <div
                class="
                  border border-brand
                  mt-3
                  p-1
                  pl-4
                  w-full
                  h-12
                  rounded-lg
                  flex
                  justify-between
                  items-center
                "
              >
                <span
                  class="text-xl md:text-lg xl:text-xl font-medium uppercase"
                  >{{ form.plan }}</span
                >
                <button
                  class="
                    border
                    px-4
                    py-2
                    md:p-2
                    rounded-lg
                    bg-brand
                    text-white
                    font-medium
                    uppercase
                  "
                  @click.prevent="back"
                >
                  Edit
                </button>
              </div>
            </div>
            <div
              class="
                sm:w-full
                md:w-1/2 md:mt-4
                lg:mt-0
                md:flex md:flex-col md:justify-end md:mb-1
                xl:block
              "
            >
              <label class="text-2xl font-light"
                >Fee
                <span class="uppercase text-xs text-grey"
                  >(billed in advance)</span
                ></label
              >
              <div class="relative mt-3">
                <button
                  type="button"
                  class="border border-grey p-1 pl-4 w-full h-12 rounded-lg"
                  @click.prevent="show_fee = !show_fee"
                >
                  <p
                    class="
                      text-black text-left
                      mr-8
                      text-xl
                      md:text-lg
                      xl:text-xl
                      font-medium
                    "
                  >
                    $
                    {{
                      convertNumeral(
                        subscriptions[form.plan][form.plan_cycle].price
                      )
                    }}
                    <span class="capitalize">{{ form.plan_cycle }}</span>
                  </p>
                  <div
                    class="
                      pointer-events-none
                      absolute
                      inset-y-0
                      right-0
                      flex
                      items-center
                      justify-center
                      px-2
                      text-grey-darker
                    "
                  >
                    <i class="fa fa-chevron-down"></i>
                  </div>
                </button>
                <div
                  class="absolute w-full border text-right bg-white rounded"
                  :class="{ invisible: !show_fee }"
                >
                  <p
                    v-for="(info, interval) in subscriptions[form.plan]"
                    :key="interval"
                    class="p-2 pr-8 hover:bg-grey-light"
                    :class="{ 'bg-grey-light': form.plan_cycle == interval }"
                    @click.prevent="selectFee(info.price, interval)"
                  >
                    <i
                      class="fa fa-check text-brand pull-left"
                      v-if="form.plan_cycle == interval"
                    ></i>
                    <span
                      >$ {{ convertNumeral(info.price) }}
                      <small class="uppercase text-grey">{{
                        interval
                      }}</small></span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </mq-layout>

        <mq-layout mq="mobile" class="flex flex-col">
          <div class="flex-1 text-center">
            <label class="text-1xl font-light">Subscription Selected</label>
            <div
              class="
                border border-brand
                mt-3
                p-1
                pl-4
                w-full
                h-12
                rounded-lg
                flex
                justify-between
                items-center
              "
            >
              <span class="text-xl font-medium uppercase">{{ form.plan }}</span>
              <button
                class="
                  border
                  px-4
                  py-2
                  rounded-lg
                  bg-brand
                  text-white
                  font-medium
                  uppercase
                "
                @click.prevent="back"
              >
                Edit
              </button>
            </div>
          </div>

          <div class="flex-1 text-center mt-4">
            <label class="text-1xl font-light"
              >Fee
              <span class="uppercase text-xs text-grey"
                >(billed in advance)</span
              ></label
            >
            <div class="relative mt-3">
              <button
                type="button"
                class="border border-grey p-1 pl-4 w-full h-12 rounded-lg"
                @click.prevent="show_fee = !show_fee"
              >
                <p class="text-black text-left mr-8 text-xl font-medium">
                  $
                  {{
                    convertNumeral(
                      subscriptions[form.plan][form.plan_cycle].price
                    )
                  }}
                  <span class="capitalize">{{ form.plan_cycle }}</span>
                </p>
                <div
                  class="
                    pointer-events-none
                    absolute
                    inset-y-0
                    right-0
                    flex
                    items-center
                    justify-center
                    px-2
                    text-grey-darker
                  "
                >
                  <i class="fa fa-chevron-down"></i>
                </div>
              </button>
              <div
                class="absolute w-full border text-right bg-white rounded"
                :class="{ invisible: !show_fee }"
              >
                <p
                  v-for="(info, interval) in subscriptions[form.plan]"
                  :key="interval"
                  class="p-2 pr-8 hover:bg-grey-light"
                  :class="{ 'bg-grey-light': form.plan_cycle == interval }"
                  @click.prevent="selectFee(info.price, interval)"
                >
                  <i
                    class="fa fa-check text-brand pull-left"
                    v-if="form.plan_cycle == interval"
                  ></i>
                  <span
                    >$ {{ convertNumeral(info.price) }}
                    <small class="uppercase text-grey">{{
                      interval
                    }}</small></span
                  >
                </p>
              </div>
            </div>
          </div>

          <div class="flex-1 text-center mt-4">
            <label class="text-1xl font-light">Payment Method</label>
            <div class="w-full py-2 pb-0 pl-0 mt-4">
              <ul class="flex">
                <li
                  v-for="(type, index) in paymentTypes"
                  :key="index"
                  class="flex-1"
                >
                  <label
                    class="
                      inline-block
                      py-4
                      px-4
                      text-left
                      border
                      sm:border-b-0
                      border-grey-light
                      font-medium
                      w-full
                    "
                    :class="{
                      'bg-white': index == form.billing.type,
                      'bg-grey-light': index != form.billing.type,
                    }"
                  >
                    <input
                      class="mr-2"
                      name="type"
                      type="radio"
                      v-model="form.billing.type"
                      :value="type.key"
                    />
                    {{ type.name }}
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </mq-layout>

        <div :class="{ 'p-6 border': $mq != 'mobile' }" class="mt-4 sm:mt-0">
          <component
            v-for="(info, payment) in paymentTypes"
            :key="payment"
            :is="payment"
            :ref="setRef(payment)"
            v-show="payment == form.billing.type"
            v-model="form.billing"
            parent-scope="set-billing-details"
            class="text-left"
            :payment-type="form.billing.type"
            @next-page="nextPage"
          >
          </component>

          <form data-vv-scope="set-billing-details">
            <div class="flex flex-wrap mt-2">
              <div class="w-full">
                <label class="font-medium text-center sm:text-left">
                  <span class="text-brand">*</span> Email Address for Invoice
                </label>
                <input
                  type="email"
                  class="w-full border py-2 px-3 mt-2 rounded"
                  v-model="form.billing.email"
                  v-validate="'required'"
                  tabindex="7"
                  name="email"
                  :class="{
                    'border-red': errors.has('set-billing-details.email'),
                  }"
                />
                <div
                  v-show="errors.has('set-billing-details.email')"
                  class="text-red text-sm mt-2"
                >
                  {{ errors.first("set-billing-details.email") }}
                </div>
              </div>
            </div>
          </form>

          <div class="text-sm mt-4">
            <p class="text-justify w-full md:max-w-5xl">
              I / We authorise Payrix Australia Pty Ltd ABN 63 135 196 397, User
              ID 382220, to debit payments from my/our account as specified above,
              at intervals and amount as directed by StrataVault (“The Business”)
              as per the Term and Conditions of my agreement with StrataVault in
              accordance with this Direct Debit Request and the Payrix DDR Service
              Agreement provided
              <a href="/DDR-Service-Agreement.pdf" target="_blank">here</a>.
            </p>
          </div>

          <div class="flex mt-4">
            <div class="self-center">
              <p class="font-bold">StrataVault</p>
              <div class="text-sm">
                <p class="mt-2">Sydney, NSW</p>
                <p>Australia</p>
              </div>
              <div class="text-sm mt-4">
                <a
                  href="tel:1300082858"
                  target="_blank"
                  class="text-black block"
                >
                  1300 0 VAULT (82858)</a
                >
                <a
                  href="mailto:team@thestratavault.com"
                  target="_blank"
                  class="text-black block mt-1"
                >
                  team@thestratavault.com</a
                >
                <a
                  href="https://www.linkedin.com/company/strata-vault-pty-ltd/"
                  target="_blank"
                  class="text-black block mt-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#0077B5"
                  >
                    <path
                      d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                    />
                  </svg>
                </a>
              </div>
              <div class="mt-2 text-sm mt-4">
                All payment information is encrypted using SSL.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-4" v-if="detailReview">
      <button
        class="
          border
          bg-grey-lighter
          p-4
          w-32
          text-black
          border-grey
          rounded
          font-medium
        "
        type="submit"
        @click="backToFinish()"
      >
        Back
      </button>
    </div>

    <div class="flex flex-row justify-between mt-4" v-else>
      <button
        class="
          border
          bg-grey-lighter
          p-4
          w-32
          text-black
          border-grey
          rounded
          font-medium
        "
        type="button"
        @click="back()"
      >
        Back
      </button>
      <button
        class="border bg-brand p-4 w-32 text-white rounded font-medium"
        type="submit"
        @click="validate()"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import DirectDebit from "./Billing/DirectDebit";
import CreditCard from "./Billing/CreditCard";

export default {
  components: {
    DirectDebit,
    CreditCard,
  },

  props: [
    "payment-types",
    "value",
    "subscriptions",
    "step",
    "detail-review",
    "steps",
  ],

  data() {
    return {
      form: _.cloneDeep(this.value),
      show_fee: false,
      next: "",
      prev: "",
      states: [
        "Australian Capital Territory",
        "New South Wales",
        "Northern Territory",
        "Queensland",
        "South Australia",
        "Tasmania",
        "Victoria",
        "Western Australia",
      ],
    };
  },

  mounted() {
    if (this.form.billing.type == "") {
      this.form.billing.type = "direct-debit";
    }

    if (this.form.plan_cycle == "") {
      this.form.plan_cycle = "monthly";
    }

    if (this.form.billing.cycle_length == "") {
      this.form.billing.cycle_length = "monthly";
    }

    let next = _.toNumber(this.step) + 1;
    this.next = next;

    let prev = _.toNumber(this.step) - 1;
    this.prev = prev;
  },

  methods: {
    convertNumeral(number) {
      return numeral(number).format("0,0.00");
    },
    selectFee(price, cycle) {
      this.form.billing.cycle_length = cycle;
      this.form.plan_cycle = cycle;
      this.show_fee = false;
    },
    back() {
      this.$emit("go-to", {
        next_step: this.prev,
      });
    },
    setRef(payment) {
      return _.snakeCase(payment);
    },
    nextPage(payload) {
      this.$emit("go-to", {
        next_step: this.next,
      });
    },
    validate() {
      this.$validator.validateAll("set-billing-details").then((result) => {
        if (result) {
          this.$emit("input", this.form);
          this.nextPage();
        }
      });
    },
    backToFinish() {
      this.$validator.validateAll("set-billing-details").then((result) => {
        if (result) {
          this.$emit("go-to", {
            next_step: _.findLastKey(this.steps),
          });
        }
      });
    },
  },

  watch: {
    form: {
      deep: true,
      handler: function () {
        this.$emit("input", this.form);
      },
    },

    "form.billing.type"() {
      this.$validator.reset();
    },
  },
};
</script>

<style></style>
